import { render } from "./DespesaGrupoEditPage.vue?vue&type=template&id=3b65c1f6"
import script from "./DespesaGrupoEditPage.vue?vue&type=script&lang=js"
export * from "./DespesaGrupoEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__